<div class="app-content" boiApplicationHostType boiDisableBodyScroll>
  <!-- This page content will be blurred/frosted when foreground loader is showed -->
  <boi-rome-ui-loader></boi-rome-ui-loader>
  <boi-vo-application-header></boi-vo-application-header>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
  <boi-vo-application-footer></boi-vo-application-footer>
  <boi-core-dialogs></boi-core-dialogs>
</div>
